import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {
  CostSummary,
  OfferType,
  ReplacementOffer,
} from '@dgx-pr-spa/shared/util';

@Component({
  selector: 'app-selected-item',
  templateUrl: './selected-item.component.html',
  styleUrls: ['./selected-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectedItemComponent {
  /**
   * Receives current item data
   */
  @Input() data: ReplacementOffer;

  /**
   * Offer Type values used to determine if enhanced model
   */
  offerType = OfferType;

  /**
   * A placeholder image
   */
  imageNotAvailable = './assets/images/img-unavailable-large-x2.png';

  @Input() costSummary: CostSummary;
}
